export default __webpack_public_path__ + "KaTeX_Script-Regular.dd0db7aef0e4e809b61410ce74227665.ttf";